export default function () {
  return {
    collection: 'site_config',
    data: [
      {
        name: 'Demo Site',
        tel: 'xxx-xxx-xxx',
        email: 'info@test.company.com',
      }
    ]
  }
}
